<template>
    <div id="rightBody" class="p-0">
        <slot name="sidebar"></slot>
    </div>
</template>

<script>
    export default {
        name:"Rightbody",
        data(){
            return {

            }
        },
    }
</script>

<style scoped>
    #rightBody{
        padding: 0px 14px 0px 14px !important;
    }
</style>




// WEBPACK FOOTER //
// src/components/overall_layouts/rightBody.vue